import { useState } from 'react'
import { dark, light } from '../themes/themes'

export const useTheme = () => {
  const [theme, setTheme] = useState(light)
  const toggle = () => {
    setTheme(theme == light ? dark : light)
  }

  return { theme, toggle }
}
